(function () {
  function setMobileNavOpen(isOpen) {
    var nav = document.getElementById('mobile-nav');
    var toggle = document.getElementById('mobile-menu-toggle');
    if (!nav || !toggle) return;
    nav.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('mobile-nav-open', isOpen);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('#mobile-menu-toggle');
    if (toggle) {
      event.preventDefault();
      var nav = document.getElementById('mobile-nav');
      if (!nav) return;
      setMobileNavOpen(!nav.classList.contains('is-open'));
      return;
    }

    var nav = document.getElementById('mobile-nav');
    if (
      nav &&
      nav.classList.contains('is-open') &&
      !event.target.closest('#mobile-nav') &&
      !event.target.closest('#mobile-menu-toggle')
    ) {
      setMobileNavOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMobileNavOpen(false);
  });

  var mobileNav = document.getElementById('mobile-nav');
  if (mobileNav) {
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setMobileNavOpen(false);
    });
  }

  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener(
      'scroll',
      function () {
        header.style.boxShadow =
          window.scrollY > 10 ? '0 4px 16px rgba(26,43,74,0.15)' : '0 2px 8px rgba(26,43,74,0.08)';
      },
      { passive: true }
    );
  }
})();
